<template>
  <b-card>
    <apuracao-list
      ref="apuracaoMitList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :mostrar-acoes-padrao="true"
      :tem-filtro-extra="true"
      :tem-limpar-filtros="true"
      @limpar-filtros="limparFiltro"
    >
      <template
        slot="filtro-extra"
      >
        <b-row>
          <b-col cols="4">
            <b-form-select
              v-model="mensal"
              @input="mudarFiltroData($event? filtroCustomData : filtroCustomAno )"
            >
              <b-form-select-option :value="true">
                Mensal
              </b-form-select-option>
              <b-form-select-option :value="false">
                Anual
              </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col cols="8">
            <b-form-input
              v-if="mensal"
              v-model="filtroCustomData"
              type="month"
              @change="mudarFiltroData($event)"
            />
            <b-select
              v-else
              v-model="filtroCustomAno"
              name="filtroSelecao"
              class="search-items"
              :options="anos"
              @input="mudarFiltroData($event)"
            />
          </b-col>
        </b-row>
      </template>
      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <b-badge
          v-if="props.column.field === 'situacaoApuracao'"
          :variant="getColorTag(String(props.row[props.column.field] || ''))"
        >
          <!--fallback para string para evitar erro quando o valor vier null/undefined -->
          <div :style="getsituacaoApuracaoDisplay(props.row).length > 26 ? 'width: 180px; white-space: normal;' : 'max-width: 280px;'">
            {{ getsituacaoApuracaoDisplay(props.row) }}
          </div>
        </b-badge>
        <div v-else-if="props.column.field === 'transmissao'">
          {{ String(props.row[props.column.field] || '') }}
        </div>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          :is-filtro-data-aplicada="isFiltroDataAplicada"
          :filtro-atual="filtroAtual"
          @atualizar-grid="atualizarGrid()"
        />
      </template>
    </apuracao-list>
  </b-card>
</template>

<style lang="scss">

.col-valores{
  white-space: nowrap;
}
[dir] #baixaSelect .vs__dropdown-toggle{
  border-color: var(--primary) !important;
}
</style>

<script>
import moment from 'moment'
import DataUtils from '@/@pilar/utils/dataUtils'
import { abilityValidation, getUserInfo } from '@/auth/utils'
import '@core/scss/vue/libs/vue-select.scss'
import service from '@/app/mit-apuracao/services/mitApuracaoService'
import colunas from '@/app/mit-apuracao/config/colunas'
import filtrosRapidosConfig from '@/app/mit-apuracao/config/filtrosRapidos'

export default {
  name: 'MitApuracaoView',
  components: {
    ApuracaoList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Acoes: () => import('@/app/mit-apuracao/components/acoes/Acoes.vue'),
  },
  data() {
    return {
      abilityUpdate: abilityValidation(2, 3),
      botoesOption: null,
      linha: null,
      mensal: true,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social',
        acaoClass: 'col-td-acao-4',
        disabledCheckbox: true,
        colunas,
        formatters: true,
      },
      filtroTipoDownload: null,
      filtroCustomData: '',
      filtroCustomAno: '',
      filtros: [],
      filtrosBase: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      filtrosRapidos: filtrosRapidosConfig,
      criando: true,
      aplicando: false,
      filtroAtual: {},
      opcoesBaixaEmLote: ['DARF', 'Recibo', 'Ambos'],
    }
  },
  computed: {
    isFiltroDataAplicada() {
      // Só vale o campo do modo ATIVO: o do outro modo continua preenchido escondido pelo
      // v-if, e em Anual sem ano nenhum recorte é enviado — dizer "aplicada" aqui faria o
      // modal de Débitos deixar de agregar o histórico (DebitosView.vue:115,127).
      return this.mensal ? this.filtroCustomData !== '' : this.filtroCustomAno !== ''
    },
  },
  created() {
    const dataUtils = new DataUtils()
    this.anos = dataUtils.getArrayAnos('2018')

    const mes = moment().subtract(1, 'month').format('yyyy-MM')
    this.mensal = !this.$route.query.filtroAno

    if (this.mensal) {
      this.filtroCustomData = this.$route.query.filtroMes ? this.$route.query.filtroMes : mes
    } else {
      this.filtroCustomAno = this.$route.query.filtroAno
    }

    if (!this.filtroCustomData) {
      this.filtroCustomData = mes
    }

    this.filtros = [...this.filtrosBase, { valor: this.montarValorPeriodo(this.mensal ? this.filtroCustomData : this.filtroCustomAno), colunas: [this.mensal ? 'MesApuracao' : 'AnoApuracao'] }]
    this.visualizacao.evento = this.carregar
  },
  methods: {
    // Sem ano escolhido, "${data}-01" viraria "-01": filtro NÃO vazio, que o backend
    // aplica e zera a grid. Vazio é o valor certo — `PrepararFiltro` descarta filtro sem
    // valor e a grid volta sem recorte de período, que é o que o campo em branco significa.
    // Usado no created e no mudarFiltroData, para as duas montagens não divergirem.
    montarValorPeriodo(data) {
      if (this.mensal) { return data || '' }
      return data ? `${data}-01` : ''
    },
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      // Adicionei verificação para incluir ordemBy baseado no mapeamento de situacaoApuracao quando o filtro for aplicado
      const filtroModificado = { ...filtro }
      if (filtroModificado.filtroBy && filtroModificado.filtroBy.some(f => f.colunas.includes('situacaoApuracao'))) {
        filtroModificado.ordemBy = [{ coluna: 'situacaoApuracao', direcao: 'asc' }]
      }
      return service.getPaginado(pagina, tamanhoPagina, filtroModificado)
    },
    getColorTag(situacaoApuracao) {
      const situacaoUpper = situacaoApuracao.toUpperCase()

      if (situacaoUpper.includes('ENCERRADA')) {
        return 'light-success'
      }
      if (situacaoUpper.includes('EM EDIÇÃO')) {
        return 'light-warning'
      }
      if (situacaoUpper.includes('ENCERRAMENTO EM CURSO')) {
        return 'light-primary'
      }
      return 'light-secondary'
    },
    baixarEmLote(evt) {
      const data = new Date()
      const nome = `DctfWeb-${getUserInfo().empresa}-${data.getDate()}-${data.getMonth() + 1}-${data.getFullYear()}`
      service.baixaEmLote(this.filtroAtual, nome, evt)
      this.filtroTipoDownload = null
    },
    mudarFiltroData(data) {
      const dataFinal = this.montarValorPeriodo(data)
      const coluna = this.mensal ? ['MesApuracao'] : ['AnoApuracao']
      const filtroData = { valor: dataFinal, colunas: coluna }
      // Remove filtros antigos de MesApuracao e AnoApuracao
      const filtrosLimpos = this.$refs.apuracaoMitList.enviarServidor.filtros.filter(filtro => !(filtro.colunas && (filtro.colunas.includes('MesApuracao') || filtro.colunas.includes('AnoApuracao'))))

      // Atualiza os filtros no componente
      this.$refs.apuracaoMitList.enviarServidor.filtros = filtrosLimpos

      const filtronew = [...this.filtrosBase, filtroData]
      this.filtros = filtronew
      this.$refs.apuracaoMitList.filtroImutavel = [...filtronew]
      this.$refs.apuracaoMitList.aplicarFiltroRapido(filtroData, false)
    },
    atualizarGrid() {
      this.$refs.apuracaoMitList.buscar()
    },
    limparFiltro() {
      this.filtroCustomData = ''
      this.filtroCustomAno = ''

      // Remove filtros antigos de MesApuracao e AnoApuracao
      const filtrosLimpos = this.$refs.apuracaoMitList.enviarServidor.filtros.filter(filtro => !(filtro.colunas && (filtro.colunas.includes('MesApuracao') || filtro.colunas.includes('AnoApuracao'))))

      // Atualiza os filtros no componente
      this.$refs.apuracaoMitList.enviarServidor.filtros = filtrosLimpos

      this.filtros = [...this.filtrosBase]
      this.$refs.apuracaoMitList.filtroImutavel = [...this.filtrosBase]
      this.$refs.apuracaoMitList.aplicarFiltroRapido(null, false)
    },
    getsituacaoApuracaoDisplay(row) {
      const situacaoApuracao = String(row.situacaoApuracao || '')
      return `${situacaoApuracao}`
    },
  },
}
</script>
